window.PeBLConfig = {
	teacher: true,
    enableDirectMessages: true,
    useIndexedDB: true
}